import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { RentaCapitalModalComponent } from '../modales/renta-capital/renta-capital/renta-capital-modal.component';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions:Question[] = [
  {question: '¿Usted tuvo ingresos por arrendamientos, rendimientos financieros, intereses, regalías o explotación de la propiedad intelectual en Colombia o en el exterior?', field: 'cs_id_393', show:true, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
];

@Component({
  selector: 'app-renta-capital',
  templateUrl: './renta-capital.component.html',
  styleUrls: ['./renta-capital.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class RentaCapitalComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();


  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) { 
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.validateComponentCompleted();
  }

  validateQuestions(id: number) {
    console.log(id);

  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      
    });
  }

  initilizeQuestionsDesdeModelo(model){
    for(let i=0; i<questions.length; i++){
      switch(i){
        case 0:
          questions[i].resp=model.doc.cuerpo.cs_id_393;
          questions[i].isCompleted = ((model.doc.cuerpo.cs_id_393 != undefined && model.doc.cuerpo.cs_id_393 =="0") || (this.validateModalCompleted(i)));
          if(questions[i].isCompleted || model.doc.cuerpo.cs_id_393 == "1"){questions[i].show = true;}
          break;
      }
      this.checkNextQuestion(i);
    }
    
  }

  openModal(indexQuestionModal:number) {
    const config = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    switch (indexQuestionModal) {
      case 0:
        let dialog0 = this.dialog.open(RentaCapitalModalComponent, config);
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
    }
    
    
  }

  protected validateModalCompleted(indexQuestion:number):boolean{
    let isModalComplete:boolean = false;
    switch(indexQuestion){
      case 0://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_424, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      default:
        break;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }
  
  protected validateHasModalValues(indexQuestion:number):boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 0://Modal 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_393, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_394, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_395, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_396, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_397, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_401, "0")){hasValues=true;break;}
        if(this.model.doc.cuerpo.cs_id_398=="1"){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_399, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_402, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_403, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_404, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_406, "0")){hasValues=true;break;}
        if(this.model.doc.cuerpo.cs_id_407=="1"){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_408, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_409, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_411, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_412, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_414, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_419, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_416, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_417, "0")){hasValues=true;break;}
        if(this.model.doc.cuerpo.cs_id_421=="1"){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_422, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_400, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_405, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_410, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_413, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_415, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_418, "0")){hasValues=true;break;}
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_420, "0")){hasValues=true;break;}
        break;
      default:
        return false;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0:
        this.model.doc.cuerpo.cs_id_394="0";
        this.model.doc.cuerpo.cs_id_395="0";
        this.model.doc.cuerpo.cs_id_396="0";
        this.model.doc.cuerpo.cs_id_397="0";
        this.model.doc.cuerpo.cs_id_401="0";
        this.model.doc.cuerpo.cs_id_398=null;
        this.model.doc.cuerpo.cs_id_399="0";
        this.model.doc.cuerpo.cs_id_400="0";
        this.model.doc.cuerpo.cs_id_402="0";
        this.model.doc.cuerpo.cs_id_403="0";
        this.model.doc.cuerpo.cs_id_404="0";
        this.model.doc.cuerpo.cs_id_405="0";
        this.model.doc.cuerpo.cs_id_406="0";
        this.model.doc.cuerpo.cs_id_407=null;
        this.model.doc.cuerpo.cs_id_408="0";
        this.model.doc.cuerpo.cs_id_409="0";
        this.model.doc.cuerpo.cs_id_410="0";
        this.model.doc.cuerpo.cs_id_411="0";
        this.model.doc.cuerpo.cs_id_412="0";		
        this.model.doc.cuerpo.cs_id_413="0";
        this.model.doc.cuerpo.cs_id_414="0";		
        this.model.doc.cuerpo.cs_id_415="0";
        this.model.doc.cuerpo.cs_id_419="0";
        this.model.doc.cuerpo.cs_id_420="0";
        this.model.doc.cuerpo.cs_id_416="0";
        this.model.doc.cuerpo.cs_id_417="0";
        this.model.doc.cuerpo.cs_id_418="0";
        this.model.doc.cuerpo.cs_id_421=null;
        this.model.doc.cuerpo.cs_id_422="0";
        this.model.doc.cuerpo.cs_id_424="0";//Indicador de Completo
        break;
    }
    console.log(this.model);
  }

  public validateComponentCompleted(): boolean{
    for(let i=0; i < questions.length; i++){
      if(questions[i].isCompleted==false){
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if(this.model.doc.cuerpo[data.field] == "0"){
      if(this.validateHasModalValues(index)){
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
          if (result) {
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateComponentCompleted();
            this.saveModel.emit(true);
          }else{
            this.model.doc.cuerpo[data.field] == "";
          }
        });
      }else{
        questions[index].isCompleted = true;
        this.cleanModalValues(index);
        this.saveModel.emit(true);
      }
    }else if (this.model.doc.cuerpo[data.field] == "1"){
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrandolo completo
      this.openModal(index);
      this.saveModel.emit(true);
      
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
    console.log(data);
    console.log(this.model);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/renta-capital/renta-capital.component.ts